import { DateTime } from "luxon";
import { jwtDecode } from "jwt-decode";

// Imported utils
import {
  getFromLocalStorage,
  removeFromLocalStorage,
} from "./storage.js";

// Check if auth token is expired
const isTokenExpired = (token) => {
  let decoded = {};
  if (token) decoded = jwtDecode(token);
  let dateTimeNow = DateTime.now().toMillis();
  if ("exp" in decoded) return decoded.exp * 1000 < dateTimeNow;
};

// Check state of user
export const isLoggedIn = () => {
  const token = getFromLocalStorage("authData")?.token || null;
  const isExpired = isTokenExpired(token);

  if (isExpired) removeFromLocalStorage("authData");

  return !!token && !isTokenExpired(token);
};

// Get user data from local storage
export const getUser = () => {
  try {
    const user = getFromLocalStorage("authData");
    return user ? user : null;
  } catch (err) {
    if (err) throw err;
    return null;
  }
};